export default "__VITE_ASSET__0abad3e3__"